<template>
    <div class="fill-height pt-5">
		<!-- dialog add or delete tag -->
		<v-dialog v-model="dialog" width="400">
			<v-card>
				<v-card-title class="pt-3 pb-0">
					<span class="title"> {{ tagId ? 'Edit tag' : 'Add tag' }} </span>
				</v-card-title>

				<v-card-text class="pt-2 pb-0">
					<v-text-field v-model="tagName" label="name" outlined filled dense hide-details="auto" />
				</v-card-text>

				<v-card-actions>
					<v-spacer />
					<v-btn
						@click="submit()"
						color="green-color white--text"
						class="text-none rounded-lg"
						:loading="submitLoading"
					>
						Save
					</v-btn>

					<v-btn
						@click="dialog = false"
						color="alert-color white--text"
						class="text-none rounded-lg"
						:disabled="submitLoading"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- delete dialog -->
		<v-dialog v-model="deleteDialog" width="400">
			<v-card>
				<v-card-title class="pt-3 pb-1">
					<span class="title"> Delete tag </span>
				</v-card-title>
				
				<v-card-text class="pb-1 pt-0 px-5">
					<span> Are you sure to deleting this tag? </span>
				</v-card-text>

				<v-card-actions class="pt-0">
					<v-spacer />
					<v-btn @click="deleteTag()" color="alert-color white--text" class="text-none rounded-lg">
						Yes
					</v-btn>

					<v-btn text @click="deleteDialog = false" class="text-none">
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

        <v-row class="mb-1">
			<v-col class="pb-0 pb-sm-1">
				<span class="title">Tags</span>
			</v-col>
			<v-spacer />
            <v-col class="d-flex justify-end">
                <v-btn @click="dialog = true" color="green-color white--text" class="text-none rounded-lg">
					<v-icon small> mdi-plus </v-icon>
                    Add new tag
                </v-btn>
            </v-col>
        </v-row>

		<!-- table -->
		<bee-handy-table
			:headers="headers"
			:items="!loading ? tags : []"
			:loading="loading"
			zebra
			dense
			pagination-on-scroll
			:height="$vuetify.breakpoint.height - 120"
			table-class="rounded-lg"
			fixed-header
			:items-per-page="-1"
		>
		
			<template v-slot:item.actions="{ item }">
				<v-btn icon color="edit-color" @click="tagId = item.id; dialog = true">
					<v-icon> mdi-pencil </v-icon>
				</v-btn>

				<v-btn icon color="alert-color" @click="tagId = item.id; deleteDialog = true">
					<v-icon> mdi-delete </v-icon>
				</v-btn>
			</template>
		</bee-handy-table>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	data () {
		return {
			headers: [
				{
					text: 'name',
					name: 'name',
					value: 'name'
				},
				{
					text: 'actions',
					name: 'actions',
					value: 'actions'
				}
			],
			dialog: false,
			loading: false,
			tagId: null,
			tagName: null,
			submitLoading: false,
			deleteDialog: false
		}
	},

	watch: {
		dialog (val) {
			if (val) {
				this.tagName = this.tags.find(c => c.id === this.tagId)?.name
			} else {
				this.tagName = null
				this.tagId = null
			}
		},
		deleteDialog (val) {
			if (!val) {
				this.tagId = null
			}
		}

	},
	computed: {
		...mapState({
			tags: state => state.tags.tags
		})
	},

	methods: {
		submit () {
			this.loading = true
			this.submitLoading = true
			console.log(this.tagId)
			const actionName = this.tagId ? 'update' : 'create'
			this.$store.dispatch(`tags/${actionName}`, { 
				name: this.tagName, 
				id: this.tagId 
			}).then(() => {
				this.fetchAll()
				this.submitLoading = false
				this.dialog = false
			}).catch(() => {
				this.submitLoading = false
				this.loading = false
			})
		},

		fetchAll () {
			this.loading = true
			this.$store.dispatch('tags/fetchAll').finally(() => {
				this.loading = false
			})
		},

		deleteTag () {
			this.$store.dispatch('tags/delete', { id: this.tagId })
		} 
	},

	created () {
		this.loading = true
		this.fetchAll()
	}
}
</script>
